
















import { Component, Prop, Vue } from 'vue-property-decorator'
import { TriggeredAction } from '@/api/model/triggered-action'

@Component
export default class CreateAutoActionVerticalStep1 extends Vue {
    @Prop({ required: true }) readonly currentStep!: number
    @Prop({ default: false }) readonly existing!: boolean
    @Prop({ required: true }) readonly value!: TriggeredAction

    get referralOriginLabel() {
        if (this.value.referralOrigin === 'internal') {
            return 'Intern'
        } else if (this.value.referralOrigin === 'external') {
            return 'Extern'
        } else {
            return 'Extern en intern'
        }
    }
}
